module.exports = __webpack_public_path__ + "img/excel.926c2e34.svg";